var activeRequest = null;
var historyListenerAdded = false;

function normalizeCatalogUrl(rawUrl) {
  var url = new URL(rawUrl, window.location.href);
  var currentUrl = new URL(window.location.href);

  if (currentUrl.hostname === url.hostname && currentUrl.port && !url.port) {
    url.host = currentUrl.host;
  }

  return url;
}

function normalizeCategoryLinks(category) {
  category.querySelectorAll('[href], [src], [action]').forEach(function (element) {
    ['href', 'src', 'action'].forEach(function (attribute) {
      var value = element.getAttribute(attribute);

      if (!value || value.charAt(0) === '#') {
        return;
      }

      var normalizedUrl = normalizeCatalogUrl(value);

      if (normalizedUrl.hostname === window.location.hostname) {
        element.setAttribute(attribute, normalizedUrl.href);
      }
    });
  });
}

function formUrl(form, priceRange) {
  var url = normalizeCatalogUrl(form.action);
  var formData = new FormData(form);

  if (priceRange) {
    var minimum = priceRange.querySelector('[data-price-min]');
    var maximum = priceRange.querySelector('[data-price-max]');
    var boundMinimum = Number(priceRange.getAttribute('data-price-bound-min'));
    var boundMaximum = Number(priceRange.getAttribute('data-price-bound-max'));

    if (minimum && maximum && Number(minimum.value) === boundMinimum && Number(maximum.value) === boundMaximum) {
      formData.delete('min_price');
      formData.delete('max_price');
    }
  }

  url.search = '';
  formData.forEach(function (value, key) {
    url.searchParams.append(key, value);
  });

  return url;
}

function focusedControlData(category) {
  var activeElement = document.activeElement;

  if (!activeElement || !category.contains(activeElement) || !activeElement.name) {
    return null;
  }

  return {
    name: activeElement.name,
    value: activeElement.value,
  };
}

function restoreFocusedControl(category, controlData) {
  if (!controlData) {
    return;
  }

  var matchingControl = Array.prototype.find.call(category.querySelectorAll('[name]'), function (control) {
    return control.name === controlData.name && control.value === controlData.value && control.type !== 'hidden';
  });

  if (matchingControl) {
    matchingControl.focus({ preventScroll: true });
  }
}

function setLoading(category, isLoading) {
  var loader = category.querySelector('[data-catalog-loader]');
  var results = category.querySelector('[data-catalog-results]');

  category.classList.toggle('is-loading', isLoading);
  category.setAttribute('aria-busy', isLoading ? 'true' : 'false');

  if (results) {
    results.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  if (loader) {
    loader.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
  }
}

function requestCategory(url, options) {
  var settings = options || {};
  var category = document.querySelector('[data-product-category]');

  if (!category) {
    window.location.assign(url.href);
    return;
  }

  var filterPanel = category.querySelector('[data-catalog-filter-panel]');
  var filtersWereOpen = Boolean(filterPanel && filterPanel.classList.contains('is-open'));
  var controlData = focusedControlData(category);
  var startedAt = Date.now();

  if (activeRequest) {
    activeRequest.abort();
  }

  var requestController = new AbortController();
  activeRequest = requestController;
  setLoading(category, true);

  fetch(url.href, {
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    signal: requestController.signal,
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Catalog request failed');
      }

      return response.text();
    })
    .then(function (html) {
      var elapsed = Date.now() - startedAt;
      var minimumLoaderTime = Math.max(0, 250 - elapsed);

      return new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(html);
        }, minimumLoaderTime);
      });
    })
    .then(function (html) {
      // A previous response may already be waiting for the loader animation.
      if (requestController.signal.aborted || activeRequest !== requestController) {
        return;
      }

      var nextDocument = new DOMParser().parseFromString(html, 'text/html');
      var nextCategory = nextDocument.querySelector('[data-product-category]');

      if (!nextCategory) {
        throw new Error('Catalog response is incomplete');
      }

      normalizeCategoryLinks(nextCategory);
      category.replaceWith(nextCategory);

      if (nextDocument.title) {
        document.title = nextDocument.title;
      }

      if (settings.updateHistory !== false) {
        window.history.pushState({ catalog: true }, '', url.href);
      }

      initProductCategory();

      if (filtersWereOpen) {
        var nextFilterPanel = nextCategory.querySelector('[data-catalog-filter-panel]');
        var nextFilterToggle = nextCategory.querySelector('[data-catalog-filter-toggle]');
        var nextFilterIcon = nextCategory.querySelector('[data-catalog-filter-icon]');

        if (nextFilterPanel && nextFilterToggle) {
          nextFilterPanel.classList.add('is-open');
          nextFilterToggle.setAttribute('aria-expanded', 'true');

          if (nextFilterIcon) {
            nextFilterIcon.textContent = '−';
          }
        }
      }

      if (settings.focusResults) {
        var nextResults = nextCategory.querySelector('[data-catalog-results]');

        if (nextResults) {
          nextResults.setAttribute('tabindex', '-1');
          nextResults.focus({ preventScroll: true });
          nextResults.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        restoreFocusedControl(nextCategory, controlData);
      }

      activeRequest = null;
    })
    .catch(function (error) {
      if (error.name === 'AbortError') {
        return;
      }

      window.location.assign(url.href);
    });
}

export default function initProductCategory() {
  var category = document.querySelector('[data-product-category]');

  if (!category) {
    return;
  }

  var filters = category.querySelector('[data-catalog-filters]');
  var sorting = category.querySelector('[data-catalog-sort]');
  var orderby = category.querySelector('[data-catalog-orderby]');
  var filterPanel = category.querySelector('[data-catalog-filter-panel]');
  var filterToggle = category.querySelector('[data-catalog-filter-toggle]');
  var filterIcon = category.querySelector('[data-catalog-filter-icon]');
  var priceRange = category.querySelector('[data-price-range]');

  function submitFilters() {
    if (filters) {
      requestCategory(formUrl(filters, priceRange));
    }
  }

  if (filterPanel && filterToggle) {
    filterPanel.classList.add('is-collapsible');

    filterToggle.addEventListener('click', function () {
      var isOpen = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (filterIcon) {
        filterIcon.textContent = isOpen ? '−' : '+';
      }
    });
  }

  if (filters) {
    filters.addEventListener('submit', function (event) {
      event.preventDefault();
      submitFilters();
    });

    filters.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      checkbox.addEventListener('change', submitFilters);
    });
  }

  if (priceRange && filters) {
    var minimum = priceRange.querySelector('[data-price-min]');
    var maximum = priceRange.querySelector('[data-price-max]');
    var minimumOutput = filters.querySelector('[data-price-min-output]');
    var maximumOutput = filters.querySelector('[data-price-max-output]');
    var progress = priceRange.querySelector('[data-price-range-progress]');

    function updatePriceRange(changedInput) {
      var lowerValue = Number(minimum.value);
      var upperValue = Number(maximum.value);
      var lowerBound = Number(minimum.min);
      var upperBound = Number(maximum.max);
      var rangeSize = upperBound - lowerBound || 1;

      if (lowerValue > upperValue) {
        if (changedInput === minimum) {
          lowerValue = upperValue;
          minimum.value = String(lowerValue);
        } else {
          upperValue = lowerValue;
          maximum.value = String(upperValue);
        }
      }

      minimumOutput.textContent = String(lowerValue);
      maximumOutput.textContent = String(upperValue);
      progress.style.left = ((lowerValue - lowerBound) / rangeSize * 100) + '%';
      progress.style.right = (100 - ((upperValue - lowerBound) / rangeSize * 100)) + '%';
    }

    [minimum, maximum].forEach(function (input) {
      input.addEventListener('input', function () {
        updatePriceRange(input);
      });

      input.addEventListener('change', submitFilters);
    });

    updatePriceRange();
  }

  if (sorting && orderby) {
    sorting.addEventListener('submit', function (event) {
      event.preventDefault();
      requestCategory(formUrl(sorting));
    });

    orderby.addEventListener('change', function () {
      requestCategory(formUrl(sorting));
    });
  }

  category.querySelectorAll('[data-catalog-clear]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      requestCategory(normalizeCatalogUrl(link.href));
    });
  });

  category.querySelectorAll('.c-pagination a').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      event.preventDefault();
      requestCategory(normalizeCatalogUrl(link.href), { focusResults: true });
    });
  });

  if (!historyListenerAdded) {
    window.addEventListener('popstate', function () {
      if (document.querySelector('[data-product-category]')) {
        requestCategory(normalizeCatalogUrl(window.location.href), { updateHistory: false });
      }
    });

    historyListenerAdded = true;
  }
}
